import { useState } from 'react';
import { apiClient } from '../utils/apiClient';

interface EnquiryData {
  name: string;
  email: string;
  phone: string;
  company?: string;
  enquiryType: string;
  message: string;
}

interface UseEnquiryReturn {
  submitEnquiry: (data: EnquiryData) => Promise<boolean>;
  isLoading: boolean;
  error: string | null;
}

export const useEnquiry = (): UseEnquiryReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submitEnquiry = async (data: EnquiryData): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    
    try {
      await apiClient.post('/api/enquiry/submit', {
        name: data.name,
        email: data.email,
        phone: data.phone,
        company: data.company,
        enquiry_type: data.enquiryType,
        message: data.message
      });
      
      return true;
    } catch (err: any) {
      setError(err.message || 'Failed to submit enquiry');
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { submitEnquiry, isLoading, error };
};